import VideoModal from "../../../components/base/video-modal";

export default class WidgetQuarantineVideo {
	constructor(props = {}) {
		this.$root = props.$root || document.getElementById('widgetQuarantineVideo');
		this.$hide = null;

		this.id = 'quarantine-video';
		this.cookie = costorage.get('h_quarantine-video');

		this.videoModal = null;

		if (!this.cookie) {
			this.init();
		}
	}

	init() {
		if (!this.$root) {
			throw new Error('Widget Quarantine Video: Root element is not defined.');
		}

		this.$hide = this.$root.querySelector('.widget-quarantine-video_close');

		this.videoModal = new VideoModal({
			id: this.id
		})

		this.$hide.addEventListener('click', e => {
			e.stopPropagation();
			this.$root.classList.remove('-visible');
			costorage.set('h_quarantine-video', 1, {
				domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua'
			});
		});

		this.$root.addEventListener('click', e => {
			this.$root.classList.remove('-visible');
			costorage.set('h_quarantine-video', 1, {
				domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua'
			});
		});

		setTimeout(() => {
			this.$root.classList.add('-visible');
		}, 3000);
	}
}